import { generatePath, matchPath } from 'react-router';
import { all, call, put, select, take, takeEvery, fork } from 'redux-saga/effects';

import { FETCH_DEALER_FAILURE, FETCH_DEALER_SUCCESS } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as core from 'modules/contactLists/actions/core';
import * as actions from 'modules/contactLists/actions/details';
import * as types from 'modules/contactLists/actionTypes';
import { fetchContactMembers } from 'modules/contactMembers/actions/core';
import { selectDealer } from 'modules/dealers/actions';
import { navigate } from 'modules/router/navigate';
import { createNotification } from 'modules/toast-notifications/actions';
import { getSelectedDealerId } from 'selectors/dealerSelectors';
import { getCurrentLocation } from 'selectors/router';

import socketSaga from './sockets';
import { CONTACT_LIST_UPDATE_STATUS, DETAILS_SOURCE } from '../constants';
import { getSelectedContactList } from '../selectors/details';

function* checkSelectedDealer({ dealerId }) {
  const selected = yield select(getSelectedDealerId);
  if (dealerId !== selected) {
    yield put(selectDealer(dealerId));
    yield take([FETCH_DEALER_SUCCESS, FETCH_DEALER_FAILURE]);
  }
}

function* initDetailsPage() {
  const location = yield select(getCurrentLocation);
  const match = matchPath(PATH.CONTACT_LISTS_DETAILS.path, location);
  const { contactListId } = match.params;

  const { error, payload: contactList } = yield putAndWait(
    core.fetchContactList(contactListId, { source: DETAILS_SOURCE })
  );

  if (!error) {
    yield all([
      call(checkSelectedDealer, contactList),
      put(fetchContactMembers(contactListId, {}, { source: DETAILS_SOURCE })),
    ]);

    yield put(actions.isInitialized());
  }
}

function* goBackOnDashboard() {
  yield call(navigate, generatePath(PATH.CONTACT_LISTS_DASHBOARD.path));
}

function* afterImportContacts({ payload }) {
  const { type } = payload.data;
  const importIsDone = type === CONTACT_LIST_UPDATE_STATUS.PROCESSED;

  if (importIsDone) {
    const { name } = yield select(getSelectedContactList);
    yield all([
      call(initDetailsPage),
      put(
        createNotification({
          type: 'success',
          message: {
            values: { name },
            id: 'page.campaigns.details.contactList.import.done',
            defaultMessage: 'Contact list "{name}" was successfully updated',
          },
        })
      ),
    ]);
  }
}

function* onDetailsWorker() {
  yield call(initDetailsPage);
  yield takeEvery(types.DELETE_CONTACT_LIST_SUCCESS, goBackOnDashboard);
  yield takeEvery(types.WS_CONTACT_LIST_UPDATED, afterImportContacts);
}

export default function* contactListsDashboardSaga() {
  yield scopeToPage([PATH.CONTACT_LISTS_DETAILS], onDetailsWorker);
  yield fork(socketSaga);
}
